export default [
  {
    heading: "Point of Contact",
    content: [
      {
        label: "First Name",
        value: "firstName",
      },
      {
        label: "Last Name",
        value: "lastName",
      },
      {
        label: "Email Address",
        value: "email",
      },
      {
        label: "How did you learn about MindSumo?",
        value: "found_out_from",
      },
    ],
  },
  {
    heading: "Company Information",
    content: [
      {
        label: "Company",
        value: "company",
      },
      {
        label: "Industry",
        value: "industry",
      },
      {
        label: "Job Title",
        value: "challengerTitle",
      },
    ],
  },
  {
    heading: "Challenge Goals & Preferences",
    content: [
      {
        label: "What kind of output do you hope to get from this challenge?",
        value: "challengeOutput",
      },
      {
        label: "Would you like the challenge to be branded or anonymous?",
        value: "anonymousOrBranded",
      },
      {
        label:
          "What timeframe should participants consider for their solutions?",
        value: "solutionsTimeframe",
      },
    ],
  },
  {
    heading: "Challenge Description",
    content: [
      {
        label: "Please describe the topic of your challenge.",
        value: "challengeTopic",
      },
      {
        label: "What questions do you hope to answer with this challenge?",
        value: "challengeQuestions",
      },
    ],
  },
  {
    heading: "Challenge Parameters",
    content: [
      {
        label:
          "What guardrails, if any, would you like to place on this challenge?",
        value: "challengeGuardrails",
      },
      {
        label:
          "What supplemental questions would you like to ask participants?",
        value: "challengeSupplementals",
      },
    ],
  },
];
